import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const faqs = [
  {
    category: 'الطلبات والشحن',
    items: [
      {
        q: 'ما هي مناطق التوصيل المتاحة؟',
        a: 'نوصل لجميع دول الخليج العربي: الإمارات، السعودية، الكويت، البحرين، قطر، وعُمان. كما نوصل لبعض الدول العربية الأخرى عند الطلب.',
      },
      {
        q: 'كم يستغرق وقت التوصيل؟',
        a: 'داخل الإمارات: 1-3 أيام عمل. باقي دول الخليج: 3-7 أيام عمل. يتم تأكيد موعد التسليم عبر واتساب بعد تقديم الطلب.',
      },
      {
        q: 'كيف أتابع طلبي؟',
        a: 'بعد تأكيد طلبك، سيتواصل معك فريقنا عبر واتساب لتزويدك برقم التتبع ومتابعة الشحنة.',
      },
      {
        q: 'هل التوصيل مجاني؟',
        a: 'رسوم التوصيل تبدأ من 25 درهم. عند الطلب بمبلغ 500 درهم فأكثر، يكون التوصيل مجانياً داخل الإمارات.',
      },
    ],
  },
  {
    category: 'المنتجات والجودة',
    items: [
      {
        q: 'هل المنتجات أصلية 100%؟',
        a: 'نعم، جميع منتجاتنا أصلية ومعتمدة من المصادر الرسمية. نضمن جودة كل منتج أو نرد لك المبلغ كاملاً.',
      },
      {
        q: 'هل يمكنني معرفة تفاصيل العطر قبل الشراء؟',
        a: 'بالطبع! تواصل معنا عبر واتساب وسيساعدك أحد خبراء العطور في اختيار ما يناسبك.',
      },
      {
        q: 'ما هي المقاسات المتاحة للملابس؟',
        a: 'تتوفر المقاسات من S حتى 4XL. لكل منتج جدول مقاسات تفصيلي. للاستفسار تواصل معنا عبر واتساب.',
      },
      {
        q: 'هل يمكنني تخصيص المنتج (إضافة اسمي مثلاً)؟',
        a: 'نعم! نقدم خدمة التخصيص لبعض المنتجات. تواصل معنا لمعرفة التفاصيل والأسعار.',
      },
    ],
  },
  {
    category: 'الدفع والإرجاع',
    items: [
      {
        q: 'ما هي طرق الدفع المتاحة؟',
        a: 'نقبل بطاقات الائتمان والخصم (Visa, Mastercard)، الدفع عبر واتساب، والدفع عند الاستلام في بعض المناطق.',
      },
      {
        q: 'هل الدفع آمن؟',
        a: 'نعم، جميع المعاملات المالية مشفرة بأعلى معايير الأمان SSL. بياناتك المالية محمية تماماً.',
      },
      {
        q: 'ما هي سياسة الإرجاع والاستبدال؟',
        a: 'يمكنك إرجاع أو استبدال المنتج خلال 14 يوم من الاستلام بشرط أن يكون بحالته الأصلية وغير مستخدم. تواصل معنا لبدء عملية الإرجاع.',
      },
      {
        q: 'متى يتم استرداد المبلغ؟',
        a: 'يتم استرداد المبلغ خلال 5-7 أيام عمل بعد استلامنا للمنتج المرتجع والتحقق منه.',
      },
    ],
  },
  {
    category: 'الحساب والخدمات',
    items: [
      {
        q: 'هل تقدمون خدمة هدايا مع التغليف الفاخر؟',
        a: 'نعم! نوفر خدمة التغليف الفاخر كهدية مع بطاقة تهنئة مخصصة بمبلغ إضافي رمزي. تواصل معنا لمعرفة التفاصيل.',
      },
      {
        q: 'كيف أتواصل مع خدمة العملاء؟',
        a: `يمكنك التواصل معنا عبر واتساب على الرقم +971547172715 أو من خلال نموذج التواصل في صفحة "اتصل بنا". نحن متاحون من السبت إلى الخميس.`,
      },
      {
        q: 'هل لديكم عروض وتخفيضات؟',
        a: 'نعم! اشترك في نشرتنا البريدية وتابعنا على وسائل التواصل الاجتماعي للحصول على أحدث العروض والتخفيضات الحصرية.',
      },
    ],
  },
];

export default function FAQPage() {
  const [openItem, setOpenItem] = useState<string | null>(null);
  const [activeCategory, setActiveCategory] = useState(faqs[0].category);

  const toggleItem = (key: string) => {
    setOpenItem(prev => prev === key ? null : key);
  };

  const active = faqs.find(f => f.category === activeCategory);

  return (
    <main>
      <Navbar />
      {/* Hero */}
      <section className="pt-32 pb-16 px-6 lg:px-12 bg-[#F5F1E8] text-center">
        <div className="max-w-3xl mx-auto">
          <span className="text-[#C9A961] text-sm font-bold tracking-widest uppercase mb-3 block">مركز المساعدة</span>
          <h1 className="text-4xl lg:text-5xl font-black text-gray-900 mb-4">الأسئلة الشائعة</h1>
          <p className="text-gray-500 text-base">إجابات لأكثر الأسئلة شيوعاً. لم تجد ما تبحث عنه؟ تواصل معنا مباشرة.</p>
        </div>
      </section>

      <section className="py-16 px-6 lg:px-12">
        <div className="max-w-4xl mx-auto">
          {/* Category Tabs */}
          <div className="flex flex-wrap items-center gap-3 mb-10 justify-center">
            {faqs.map(f => (
              <button
                key={f.category}
                onClick={() => setActiveCategory(f.category)}
                className={`px-5 py-2.5 rounded-full text-sm font-semibold transition-all cursor-pointer whitespace-nowrap ${
                  activeCategory === f.category
                    ? 'bg-[#C9A961] text-white'
                    : 'bg-[#F5F1E8] text-gray-600 hover:bg-[#C9A961]/10'
                }`}
              >
                {f.category}
              </button>
            ))}
          </div>

          {/* FAQ Items */}
          <div className="space-y-3" itemScope itemType="https://schema.org/FAQPage">
            {active?.items.map((item, i) => {
              const key = `${activeCategory}-${i}`;
              const isOpen = openItem === key;
              return (
                <div
                  key={key}
                  className={`bg-white rounded-2xl border-2 transition-all duration-300 ${isOpen ? 'border-[#C9A961]' : 'border-gray-100'}`}
                  itemScope
                  itemProp="mainEntity"
                  itemType="https://schema.org/Question"
                >
                  <button
                    onClick={() => toggleItem(key)}
                    className="w-full flex items-center justify-between p-6 text-right cursor-pointer"
                  >
                    <div className="w-8 h-8 flex items-center justify-center rounded-full border-2 border-gray-200 flex-shrink-0 transition-all">
                      <i className={`${isOpen ? 'ri-subtract-line text-[#C9A961]' : 'ri-add-line text-gray-400'} text-sm`} />
                    </div>
                    <h4 className="text-gray-900 font-bold text-base flex-1 text-right mr-4" itemProp="name">
                      {item.q}
                    </h4>
                  </button>
                  {isOpen && (
                    <div
                      className="px-6 pb-6 text-gray-600 text-sm leading-relaxed text-right"
                      itemScope
                      itemProp="acceptedAnswer"
                      itemType="https://schema.org/Answer"
                    >
                      <p itemProp="text">{item.a}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          {/* Still need help */}
          <div className="mt-16 bg-[#F5F1E8] rounded-2xl p-8 text-center">
            <div className="w-14 h-14 flex items-center justify-center bg-[#C9A961]/10 rounded-full mx-auto mb-4">
              <i className="ri-question-line text-2xl text-[#C9A961]" />
            </div>
            <h3 className="text-xl font-black text-gray-900 mb-2">لم تجد إجابتك؟</h3>
            <p className="text-gray-500 text-sm mb-6">فريقنا جاهز للرد على جميع استفساراتك</p>
            <div className="flex flex-wrap items-center justify-center gap-4">
              <a
                href="https://wa.me/971547172715"
                target="_blank"
                rel="nofollow noreferrer"
                className="flex items-center gap-2 bg-[#25D366] text-white px-6 py-3 rounded-xl font-bold cursor-pointer whitespace-nowrap hover:bg-[#1da851] transition-colors"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-whatsapp-line text-lg" />
                </div>
                واتساب
              </a>
              <a
                href="/contact"
                className="flex items-center gap-2 bg-[#C9A961] text-white px-6 py-3 rounded-xl font-bold cursor-pointer whitespace-nowrap hover:bg-[#A07C30] transition-colors"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-send-line text-lg" />
                </div>
                نموذج التواصل
              </a>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </main>
  );
}
